<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md6 lg6>
        <v-card >
          <v-toolbar dense flat >
            <v-toolbar-title>Регистрация в системе</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            В Системе "АТЛАНТ-СМАРТ" могут работать только представители компаний.
            <v-form v-model="valid" ref="form">
              <v-layout row>
              <v-btn @click="selectClient">Указать компанию</v-btn>
              </v-layout>
              <div>
              <div v-if="!!company.name">
              <b>{{company.name.value}}</b>
              </div>
              <div v-show="!!company.inn">
              ИНН: <b>{{formats.formatInn(company.inn)}}</b>
              </div>
              <div v-show="!!company.address">
              Адрес: <b>{{!!company.address ? company.address.value : ''}}</b>
              </div>
              <div v-show="!!company.heads">
              <span v-html = "formatHeads(company.heads)"></span>
              </div>
              <p>
              <div v-show="!!company.heads">
              <b><span v-html = "formatHeadNames(company.heads)"></span>,</b> если это Вы, то укажите эл. почту для направления Вам счета с реквизитами для совершения Вашей компанией удостоверяющего платежа.
              </div>
              </p>
              </div>
              <v-text-field  v-show="!!company.heads"
                v-model = "request.email"
                label="Введите адрес эл. почты для посылки счета"
                :rules="emailRules"
                type="text"
                clearable
              ></v-text-field>
              <div>
                <div>
                <a :href="getDepoUrl(getOpenSettings.useRules)">Лицензионное соглашение</a>
                </div>
                <div>
                <a :href="getDepoUrl(getOpenSettings.personInfoRules)">Политика обработки персональных данных</a>
                </div>
                <div>
                <a :href="getDepoUrl(getOpenSettings.personInfoAgreement)">Согласие на обработку персональных данных</a>
                </div>
                <v-checkbox label="Даю согласие" persistent-hint
                  hint="Политику обработки персональных данных изучил, Даю свое соглашение на обработку моих персональных данных" v-model="personAgreementCheck"></v-checkbox>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn block :disabled="!valid || !this.request.inn || !personAgreementCheck " color="primary" @click="registerRequest">Получить счет</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import apimix from '../common/apimix'
  import server from '../../api/server'
  import dialogs from '../common/dialogs'
  import vClientSelector from '../client/ClientSelector.vue'

  export default {
    components: {},
    mixins: [apimix],
    data: () => ({
      valid: false,
      request: {
        inn: '',
        email: ''
      },
      company: null,
      personAgreementCheck: false,
      emailRules: [
        v => !!v || 'Введите адрес электронной почты, для отсылки счета',
        v => formats.isEmail(v) || 'Неверный формат эл. почты'
      ]
    }),
    created () {
      this.initCompany()
    },
    mounted () {
    },
    computed: {
      ...mapGetters({
        getOpenSettings: 'getOpenSettings',
        getDepoUrl: 'getDepoUrl'
      })
    },
    methods: {
      initCompany () {
        this.company = {
          name: null,
          head: {
            position: null,
            lastName: null,
            firstName: null,
            middleName: null
          }
        }
      },
      formatHeads (heads) {
        return heads ? heads.map(h => ''.concat(h.position, ': ', '<b>', h.nameFull, '</b>')).join('<br/>') : ''
      },
      formatHeadNames (heads) {
        return heads ? heads.map(h => ''.concat('<b>', h.firstName, ' ', h.middleName, '</b>')).join(', ') : ''
      },
      setPartner: function (value) {
        if (value.length > 0) {
          let ms = /ogrn:(\d{13})/.exec(value[0])
          console.log('setPartner', value)
          if (ms && ms.length > 1) {
            this.$store.dispatch('getCompanyProps', ms[1]).then(data => {
              this.company = data
              this.request.inn = this.company ? this.company.inn : null
            })
          } else {
            this.company = null
            this.request.inn = null
            this.$store.commit('setWarningStatus', 'Тип организации не поддерживается.')
          }
        } else {
          this.company = null
          this.request.inn = null
        }
      },
      selectClient () {
        dialogs.register('v-client-selector', vClientSelector)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var setItem = this.setPartner
        var comp = { template: `
          <v-client-selector v-on:close="$emit('close')"
          v-on:input="setItem"
          :fullscreen="fullscreen" radio
          refCode
          ></v-client-selector>
          `,
          data () {
            return {
              fullscreen: fullscreen,
              setItem: setItem
            }
          }
        }
        dialogs.modal(comp)
      },
      registerRequest () {
        if (this.$refs.form.validate()) {
          server.openApiPost(
          '/openapi/register-requests',
          this.request,
          (data) => {
            this.$store.commit('setStatus', {
              show: true,
              type: 'success',
              message: 'На адрес ' + this.request.email + ' был отправлен счет для совершения Вашей компанией удостоверяющего платежа'
            })
            this.$store.dispatch('logout')
          },
          (e) => {
            this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении счета для регистрации '})
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Register.vue?e5f17304